module.exports = {"server":{"protocol":"https","port":4121,"host":"api.rocklititz.com","origin":"https://api.rocklititz.com"},"client":{"activationLanding":"https://rocklititz.com/RLX/Login?activated=true","origin":"https://rocklititz.com"}}


//////////////////
// WEBPACK FOOTER
// ./env.json
// module id = 208
// module chunks = 0